import defaultUserImage from "../../../../assets/images/default_profile_pic.jpeg";
import { Avatar, AvatarFallback, AvatarImage } from "../../../../components/ui/common/avatar";
import { cn } from "../../../../lib/utils";

interface UserAvatarProps {
  src?: string | null;
  alt?: string;
  /** When set, shown as initials in a tinted circle if there is no picture; otherwise the legacy default image is used. */
  initials?: string;
  className?: string;
}

/** Round profile picture with an initials or default-image fallback. */
const UserAvatar = ({ src, alt = "User profile", initials, className }: UserAvatarProps) => (
  <Avatar className={cn("tw-h-10 tw-w-10", className)}>
    {src || !initials ? (
      <AvatarImage src={src || defaultUserImage} alt={alt} className="tw-object-cover" />
    ) : null}
    {initials ? (
      <AvatarFallback className="tw-border tw-border-border tw-bg-muted tw-text-xs tw-font-medium tw-text-foreground">
        {initials}
      </AvatarFallback>
    ) : null}
  </Avatar>
);

export default UserAvatar;
